module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qback4-cf567f1936c56bafb5bb8e517642604e.jpg";